import { render, staticRenderFns } from "./town-hall.vue?vue&type=template&id=6e1a7d7f&scoped=true&"
import script from "./town-hall.vue?vue&type=script&lang=js&"
export * from "./town-hall.vue?vue&type=script&lang=js&"
import style0 from "./town-hall.vue?vue&type=style&index=0&id=6e1a7d7f&lang=scss&scoped=true&"
import style1 from "./town-hall.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1a7d7f",
  null
  
)

export default component.exports